import React from 'react';
export function SupportingTestimonials() {
  const testimonials = [{
    quote: "We knew AI was going to change how we worked, but we didn't have a foundation or a strategy for it. Working with Michael helped us develop both in a thoughtful and meaningful way. He quickly established rapport with our diverse team, and he brought a hands-on approach that got even our most resistant team members engaging with AI productively. The work established a foundation that the firm is able to continue building on.",
    author: 'Kate Grimes',
    role: 'Former Director, Snøhetta',
    initials: 'KG',
    image: 'https://cdn.magicpatterns.com/uploads/1aePCKVAYng7ty7ubyRSrJ/27f990f8-bc4d-490f-adc1-88a7baa5c324.jpg',
    // Photo is a wide shot with a dog — zoom in so her face fills the avatar.
    imageClassName: 'scale-[2] origin-[60%_16%]'
  }, {
    quote: "Unlike previous training efforts that weren't applicable to daily work, Michael's approach was practical and meaningful. Our product teams are now much more curious about AI and it's become part of their regular workflow.",
    author: 'Carsten Wierwille',
    role: 'VP of Product and Design, HTEC Group',
    initials: 'CW',
    image: 'https://cdn.magicpatterns.com/uploads/qW1THK3pnfcFH8HpCxBkjb/image.jpg'
  }, {
    quote: "The course didn't just teach me tools — it gave me the strategic foundation and confidence to take on AI leadership roles. Seven months later, I'm leading our AI development team and presenting AI roadmaps to enterprise clients.",
    author: 'Kate Mosley',
    role: 'Group Product Manager',
    initials: 'KM',
    image: 'https://cdn.magicpatterns.com/uploads/dZbRkgqJwtFqwChPqoMTqs/image.jpg'
  }, {
    quote: 'This class is a cheat code for Product Managers and Leaders who need to accelerate their understanding and use of AI to build and ship in this new era.',
    author: 'John',
    role: 'Digital Media Product Consultant',
    initials: 'J',
    image: 'https://cdn.magicpatterns.com/uploads/kQaBmYBGxdKgGbxNz9YDez/image.jpg'
  }];
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-457" data-mp="309kdga4hjv5a">
      <div className="max-w-7xl mx-auto" data-id="element-458" data-mp="358ev38qpvdnt">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-459" data-mp="3573shc90cbya">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-10 rounded-lg shadow-sm border-l-4 border-brand-orange flex flex-col h-full" data-id="element-460" data-mp="2qi7lzjmln6zs" data-mpi={index}>
              <blockquote className="text-brand-navy text-lg leading-relaxed mb-10 flex-grow italic" data-id="element-461" data-mp="2hjvmes3r8yv7">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-3" data-id="element-462" data-mp="27kwp25ofwpni">
                <div className="w-10 h-10 rounded-full bg-brand-light-gray border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-463" data-mp="27lethpl9aa6i">
                  {testimonial.image ? <img src={testimonial.image} alt={testimonial.author} className={`w-full h-full object-cover ${'imageClassName' in testimonial ? testimonial.imageClassName : ''}`} data-id="element-464" data-mp="1sy7oe0igc6fj" /> : <span className="text-brand-gray-light text-xs font-bold" data-id="element-465" data-mp="1xvpr395vlpf3">
                      {testimonial.initials}
                    </span>}
                </div>
                <div data-id="element-466" data-mp="27uoykoewnf0i">
                  <div className="font-bold text-brand-navy" data-id="element-467" data-mp="27tdxiwcugld3">
                    {testimonial.author}
                  </div>
                  <div className="text-brand-gray-light text-sm" data-id="element-468" data-mp="2gn0ehgce7k28">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}